module.exports = __webpack_public_path__ + "img/BE0546596384.5899c49b.svg";